import { FC, PropsWithChildren, ReactNode } from 'react'
import styles from './footer-info.module.scss'
import classNames from '@/utils/helpers/class-names.helper'
import { useTranslation } from 'react-i18next'

type FooterInfoProps = {
  keyI18n: string
  values?: ReactNode[]
  valueAccent?: boolean
  valueI18n?: string
}

const FooterInfo: FC<PropsWithChildren<FooterInfoProps>> = ({
  keyI18n,
  values,
  valueAccent = false,
  children,
  valueI18n,
}) => {
  const { t } = useTranslation()
  return (
    <div className={styles.info}>
      <div className={styles.key}>{t(keyI18n)}</div>
      {values?.map((value, i) => (
        <div
          className={classNames(styles.value, valueAccent && '_accent')}
          key={`footer_info_${keyI18n}_${i}`}
        >
          {value}
        </div>
      ))}
      {valueI18n && (
        <div className={classNames(styles.value, valueAccent && '_accent')}>{t(valueI18n)}</div>
      )}
      {children}
    </div>
  )
}

export default FooterInfo
